import React from "react";
import { useGetAotdByNumberQuery } from "../printsApi";
import type { PrintPreorder } from "../printsApi";
import { FORMATS } from "../printProducts";
import { dayLabel } from "../dayFormat";
import { MAX_QUANTITY, preorderErrorText, usePreorders } from "../usePreorders";
import type { Preorders } from "../usePreorders";
import { PrintFaceThumb } from "../showcase/PrintFaceThumb";

// Every poster and wall card the member has pre-ordered, any day, newest day first. Older days have
// no page of their own any more, so they are changed here: one less, one more, or remove (going
// below one asks first: removing is final). Gathered trading cards are listed in GatheredCards.

const Row: React.FC<{ preorder: PrintPreorder; pre: Preorders }> = ({ preorder, pre }) => {
  const { data: day, isError } = useGetAotdByNumberQuery(preorder.number);
  const info = FORMATS.find((f) => f.format === preorder.format);
  if (isError || !info) return null;
  const original = preorder.edition === "original";
  const set = (q: number) => pre.setQuantity(preorder.number, preorder.format, preorder.edition, q);
  return (
    <li className="tp-mine-row">
      <span className="tp-mine-face">
        {day ? <PrintFaceThumb day={day} format={preorder.format} edition={preorder.edition} width={preorder.format === "trading-card" ? 34 : 48} /> : null}
      </span>
      <span className="tp-mine-what">
        <b>
          #{preorder.number} {original ? `original ${info.name}` : info.name}
        </b>
        <span>{day ? `${day.title} · ${dayLabel(day)}` : " "}</span>
      </span>
      {original ? (
        <button type="button" className="tp-link-btn" disabled={pre.busy} onClick={() => set(0)}>
          let it go
        </button>
      ) : (
        <span className="tp-step" aria-label={`${preorder.quantity} pre-ordered`}>
          <button type="button" disabled={pre.busy} onClick={() => set(preorder.quantity - 1)} aria-label="one less">
            −
          </button>
          <b>{preorder.quantity}</b>
          <button type="button" disabled={pre.busy || preorder.quantity >= MAX_QUANTITY} onClick={() => set(preorder.quantity + 1)} aria-label="one more">
            +
          </button>
        </span>
      )}
    </li>
  );
};

export const MyPreorders: React.FC = () => {
  const pre = usePreorders();
  if (!pre.signedIn || pre.list.length === 0) return null;
  const list = [...pre.list].sort((a, b) => b.number - a.number);
  return (
    <section className="tp-mine" aria-labelledby="tp-mine-title">
      <h2 id="tp-mine-title" className="tp-h2">
        your pre-orders
      </h2>
      <p className="tp-note">they wait here until prints go on sale. nothing is paid yet. change how many any time; removing one is final.</p>
      <ul className="tp-mine-list">
        {list.map((p) => (
          <Row key={p.id} preorder={p} pre={pre} />
        ))}
      </ul>
      {pre.error ? <p className="tp-error">{preorderErrorText(pre.error)}</p> : null}
    </section>
  );
};

export default MyPreorders;
